import React from 'react';
import Spinner from './loader';

const LoadingOverlay = ({
    loading,
    showCondition = true,
    pointerEvents = 'none',
    backgroundColor = 'rgba(255, 255, 255, 1)',
    zIndex = 10
}) => {
    if (!loading || !showCondition) {
        return null;
    }

    return (
        <div
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: zIndex,
                pointerEvents: pointerEvents
            }}
        >
            <Spinner />
        </div>
    );
};

export default LoadingOverlay;

